/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const TranslationIcon = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.0645 3H9.74194V6.09278H11.0323V4.23711H20.0645C20.4516 4.23711 20.7097 4.48454 20.7097 4.85567V11.6598C20.7097 12.0309 20.4516 12.2784 20.0645 12.2784H11.6774V16.6082H8.25806L5.87097 18.4021V16.6082H3.93548C3.54839 16.6082 3.29032 16.3608 3.29032 15.9897V9.18557C3.29032 8.81443 3.54839 8.56701 3.93548 8.56701H12.3226V7.3299H3.93548C2.83871 7.3299 2 8.13402 2 9.18557V15.9897C2 17.0412 2.83871 17.8454 3.93548 17.8454H4.58065V21L8.64516 17.8454H12.9677V13.5155H20.0645C21.1613 13.5155 22 12.7113 22 11.6598V4.85567C22 3.80412 21.1613 3 20.0645 3Z"
          fill="#002967"
        />
        <path
          d="M4.70898 15.3092H6.25737L6.64447 14.3195H8.64447L9.03157 15.3092H10.58L8.3864 9.80408H6.83802L4.70898 15.3092ZM7.61221 11.3505L8.25737 13.268H6.96705L7.61221 11.3505Z"
          fill="#002967"
        />
        <path
          d="M13.6133 11.6598C14.323 11.6598 15.2907 11.4743 16.1939 11.0413C17.0972 11.4743 18.1294 11.6598 18.7746 11.6598V10.4227C18.7746 10.4227 18.1294 10.4227 17.4197 10.1753C18.1939 9.43303 18.7746 8.31963 18.7746 6.71138V6.09283H16.8391V4.85571H15.5488V6.09283H13.6133V7.32994H17.4197C17.2907 8.44334 16.7746 9.12375 16.1939 9.55674C15.8068 9.24747 15.4197 8.81448 15.1617 8.25777H13.8068C14.0649 9.0619 14.452 9.68046 14.9681 10.1753C14.323 10.4227 13.7423 10.4227 13.6133 10.4227V11.6598Z"
          fill="#002967"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4701_32871)">
        <path
          d="M14.4516 0.799927H6.19355V3.27415H7.22581V1.78962H14.4516C14.7613 1.78962 14.9677 1.98756 14.9677 2.28446V7.72776C14.9677 8.02467 14.7613 8.22261 14.4516 8.22261H7.74194V11.6865H5.00645L3.09677 13.1216V11.6865H1.54839C1.23871 11.6865 1.03226 11.4886 1.03226 11.1917V5.74838C1.03226 5.45147 1.23871 5.25353 1.54839 5.25353H8.25806V4.26384H1.54839C0.670968 4.26384 0 4.90714 0 5.74838V11.1917C0 12.0329 0.670968 12.6762 1.54839 12.6762H2.06452V15.1999L5.31613 12.6762H8.77419V9.2123H14.4516C15.329 9.2123 16 8.569 16 7.72776V2.28446C16 1.44323 15.329 0.799927 14.4516 0.799927Z"
          fill="#002967"
        />
        <path
          d="M2.16797 10.6473H3.40668L3.71636 9.85553H5.31636L5.62603 10.6473H6.86474L5.1099 6.24316H3.87119L2.16797 10.6473ZM4.49055 7.48028L5.00668 9.0143H3.97442L4.49055 7.48028Z"
          fill="#002967"
        />
        <path
          d="M9.29297 7.7276C9.86071 7.7276 10.6349 7.57915 11.3575 7.23276C12.0801 7.57915 12.9059 7.7276 13.422 7.7276V6.73791C13.422 6.73791 12.9059 6.73791 12.3381 6.53997C12.9575 5.94616 13.422 5.05544 13.422 3.76884V3.27399H11.8736V2.2843H10.8414V3.27399H9.29297V4.26368H12.3381C12.2349 5.15441 11.822 5.69874 11.3575 6.04513C11.0478 5.7977 10.7381 5.45131 10.5317 5.00595H9.44781C9.65426 5.64925 9.96394 6.1441 10.3768 6.53997C9.86071 6.73791 9.39619 6.73791 9.29297 6.73791V7.7276Z"
          fill="#002967"
        />
      </g>
      <defs>
        <clipPath id="clip0_4701_32871">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TranslationIcon;
